<div class="maintenance content-container">
  <h1 class="title text-center">Allianz eAZy Pension</h1>
  <div class="description text-center">
    <p class="text-center" [innerHtml]="'global.maintenance.description1' | translate"></p>
    <p class="text-center" [innerHtml]="'global.maintenance.description2' | translate"></p>
  </div>
</div>
